//страница планирования меню

import React from 'react'; 
import {Loader, Popup, SimpleCalendar } from '..'
import {Link } from 'react-router-dom' 
import {TooltipNo, TooltipLabel, InputCounter, ReasonDislike} from '../../atoms'
import {Tabs } from '../../molecules'
import { useDispatch, useSelector } from 'react-redux'
import './MenuPattern.css'
import { useRef } from 'react'; 
import { priceDish, Cals, findDeclension } from "../../../utils/utils"; 
import { CalculateIngredients } from '../../pages' 
import { meals, days } from "../../../constants/constants.js";   
import { handleDislikeInPlan } from '../../../store/api.js'; 

export function MenuPattern(props) {
  const item = props.item
  const { currentUser, rate, statusUser } = useSelector(state => state.currentUser)  
  const {ingredients, status} = useSelector(state => state.ingredients)
  const [isOpen, setIsOpen] = React.useState(false)
  const { date, breakfast, lunch, supper, dinner, snack, lateDinner } = item
  const {plans, statusPlan } = useSelector(state => state.plans) // Сохраненные планы с сервера
  const d = new Date(date);
  const n = d.getDay(); 
  const today = new Date();  
  const {recipesLimitData, statusLim} = useSelector(state => state.recipes) 
  const day = String(d.getDate()).padStart(2, '0'); // Получаем день и добавляем ноль перед числом, если нужно
  const month = String(d.getMonth() + 1).padStart(2, '0'); // Получаем месяц и добавляем ноль, так как months начинаются с 0
  const blockedSaveMenu = date < today.setHours(0,0,0,0)
  const formattedDate = `${day}/${month}`;
  const [click, setClick] = React.useState(false) 
  const [dishes, setDishes] = React.useState([]) 
 // const [zeroMeals, setZeroMeals] = React.useState([]) 
  const [calculation, setCalculation] = React.useState({}) 
  const [mainMeals, setMainMeals] = React.useState([])
  const [showCal, setShowCal] = React.useState(false)
  const label1 = rate.subs === 'free'; 
  //const label1 = false
  const mealsRef =  useRef()
  const calRef = React.useRef()

  
  React.useEffect(()=> { 
    const newDishes = [
      { arr: breakfast ?? [], mealsRu: 'Завтрак', mealsEn: 'breakfast' },
      { arr: lunch ?? [], mealsRu: 'Ланч', mealsEn: 'lunch' },
      { arr: dinner ?? [], mealsRu: 'Обед', mealsEn: 'dinner' },
      { arr: snack ?? [], mealsRu: 'Полдник', mealsEn: 'snack' },
      { arr: supper ?? [], mealsRu: 'Ужин', mealsEn: 'supper' },
      { arr: lateDinner ?? [], mealsRu: 'Поздний ужин', mealsEn: 'lateDinner' },
    ];
    setDishes(newDishes)
    // Сразу фильтруем новые данные
    const filteredMainMeals = newDishes.filter(
      i => i.mealsEn === 'breakfast' || 
           i.mealsEn === 'dinner' || 
           i.mealsEn === 'supper' || 
           i.arr.length > 0
    );
    setMainMeals(filteredMainMeals);
   // setZeroMeals(newDishes.filter(i=> !i.arr || !filteredMainMeals.some(m => m.mealsEn === i.mealsEn)));
  }, [item])

  const zeroMeals = dishes.filter(i=> !i.arr || !mainMeals.some(m => m.mealsEn === i.mealsEn))

  React.useEffect(()=> {
    if(statusPlan === 'resolved') {
      setClick(false)
    }
  }, [statusPlan])

  React.useEffect(() => {  
    if(status === 'resolved' && statusPlan ==='resolved' && statusLim === 'resolved') { 
     const calc = countSumCalories()
     setCalculation(calc)
       
    }
  }, [item, statusLim]) 

  React.useEffect(() => {
    const click = e => {
      if (isOpen && mealsRef.current && !mealsRef.current.contains(e.target) && !e.target.classList.contains('gg-add') ) {
        setIsOpen(false)
      }
     }
    document.addEventListener("mousedown", click)
      return () => {
        document.removeEventListener("mousedown", click)
      }
  }, [isOpen])
  //функция добавления блюда в план
  function handleAddDish(mealsRu, mealsEn) {
    if(!blockedSaveMenu) {
      props.handleAddDish(mealsRu, mealsEn, item)
    } else {
      props.blockedSaveMenus('blockedUpdateMenu')
    } 
  }

  function handAutoReplace(mealsRu, mealsEn) {
    if(!blockedSaveMenu) { 
      props.handleAutoMeals(mealsEn, item._id)
    } else {
      props.blockedSaveMenus('blockedUpdateMenu')
    } 
  }



                               /* Действия с планом на день*/ 
  //функция удаления меню с определенного дня
  function handleDeleteMenuDay() {
    if(!blockedSaveMenu) {
      props.handleDeleteMenuDay(item._id)
      setClick(true)
    } else {
      props.blockedSaveMenus('blockedUpdateMenu')
    }  
  }

  // Автозамена плана на день
  function handleAutoReplaceMenu() { 
    if(!blockedSaveMenu) { 
      props.handleAutoReplaceMenu(item)
      setClick(true)
    } else {
      props.blockedSaveMenus('blockedUpdateMenu')
    } 
  } 
  
  // Добавления дополнительного приема пищи в план
  function handleOpenAddMeals() {
    if(!blockedSaveMenu) {
      setIsOpen(!isOpen)
    } else {
      props.blockedSaveMenus('blockedSaveMenu')
    }  
  }

  //Добавление приема пищи в план
  function handleAddMeals(meals) {
    props.handleAddMeals(meals, item) 
    setIsOpen(!isOpen)
  } 

  //Удаление приема пищи из плана-шаблона
  function handleDeleteDish(mealsRu, mealsEn) {
    if(!blockedSaveMenu) {
      setMainMeals((cards) => 
      cards.filter((c) => !(c.mealsEn === mealsEn))
    );
    } else {
      props.blockedSaveMenus('blockedUpdateMenu')
    } 
  } 

  //функция удаления блюда из плана
  function handleDeleteRecipe(id, powerMode, index) {
    if(!blockedSaveMenu) {
      props.handleDeleteRecipe(id, powerMode,index, item._id)
    } else {
      props.blockedSaveMenus('blockedUpdateMenu')
    }  
  }

    //функция добавления блюда в план
    function handleAddExcessDish(mealsRu, mealsEn) {
      if(!blockedSaveMenu) {
        props.handleAddExcessDish(mealsRu, mealsEn, item)
      } else {
        props.blockedSaveMenus('blockedUpdateMenu')
      } 
    }

  //функция замены блюда из плана
  function handleEdite(id, mealsEn, mealsRu, index) {
    if(!blockedSaveMenu) {
      props.handleEdite(id, mealsEn, mealsRu, index, item._id)
    } else {
      props.blockedSaveMenus('blockedUpdateMenu')
    }   
  }

  //функция автозамены блюда из плана
  function handleAutoReplace(id, cal, category, mealsEn, index) {
    if(!blockedSaveMenu) {
      props.handleAutoReplaceDish(id, cal, category, mealsEn, index, item._id)
    } else {
      props.blockedSaveMenus('blockedUpdateMenu')
    }   
  }

  //функция изменения количества порций в плане
  function handleChange(serv, weight, itemId, category, mealsEn, index) {
    if(!blockedSaveMenu) { 
      props.handleChangeCount(serv, weight, itemId, category, mealsEn, index, item._id)
    } else {
      props.blockedSaveMenus('blockedUpdateMenu')
    }   
  }

  function handleChangeEvents(el) { 
    if(label1)  {
      setMainMeals([...mainMeals, el]); 
      setIsOpen(false)
    } else {
      props.handleAutoMeals(el.mealsEn, item._id)
    }
    
  }


  function countSumCalories() {
    let cal= 0
    let protein= 0
    let carb= 0
    let fats= 0
    let price= 0
    const dex = {...item}   
    if(!dex.nutritionTotals) {
    Object.values(dex).map((d) => { 
      if(Array.isArray(d) && d.length> 0) {  
        const fin = d.filter(i=>!i.weight)
        fin.map(item => {
          let showRecipe = recipesLimitData.find(r => r._id === item)
          if(showRecipe !== undefined) {
            let result = showRecipe.ingredients.reduce(function(acc,v, index){ 
            const ingredient = ingredients.find(f => f._id === v._id);
            if(ingredient  !== undefined) {
              const totalWeights = ingredient.measure.find(i=> i.nameRu === v.choisMeasure)

              if(totalWeights) {
                const totalWeight = totalWeights.ratio*v.weight;
                acc.calories += Number(ingredient.calories.calories*totalWeight/100)
                acc.protein += Number(ingredient.calories.protein*totalWeight/100)
                acc.fats += Number(ingredient.calories.fats*totalWeight/100)
                acc.carb += Number(ingredient.calories.carb*totalWeight/100)
              if(ingredient.price) {
                if(item.choisMeasure === ingredient.mainMeasure && ingredient.price.measureprice === ingredient.mainMeasure) {
                  const price = (ingredient.price.rate/ingredient.price.weightprice)*item.weight
                  acc.price += Number(price)
                } else { 
                  //перевести цену за основной вес
                  const rightPrice = ingredient.measure.find(i=> i.nameRu === ingredient.price.measureprice).ratio
                  const price = (ingredient.price.rate/(ingredient.price.weightprice*rightPrice)) * totalWeight
                  acc.price += Number(price)
                } 
              }
            }
            }
              return acc;
          }, { calories:0, price: 0, protein: 0, fats: 0, carb: 0});
         
          cal += result.calories/showRecipe.servings
          protein += result.protein/showRecipe.servings
          fats += result.fats/showRecipe.servings
          carb += result.carb/showRecipe.servings
          price += result.price/showRecipe.servings
        }
         })
        }
      })
    } else {
      cal = dex.nutritionTotals.calories
      protein = dex.nutritionTotals.protein
      carb = dex.nutritionTotals.carb
      fats = dex.nutritionTotals.fats

    } 
    return {cal, price, carb, fats, protein} 
  }

  function handleDate(date) {  
  }

  React.useEffect(() => {
    const click = e => {
      if (showCal && calRef.current && !calRef.current.contains(e.target) && !e.target.classList.contains('gg-copy') ) {
        setShowCal(false)
      }
     }
    document.addEventListener("mousedown", click)
      return () => {
        document.removeEventListener("mousedown", click)
      }
  }, [showCal])
 
  //Открытие и закрытие календаря для добавления в рецепт
  function handleOpenCal() { 
    setShowCal(!showCal)
  }

  function handleCopyPlan(date) { 
    setShowCal(false) 
    props.handleCopyPlan(date, item._id)
  }
 
  return (
      <>
    <article className='menu-pattern flexColCenter'>
      <div className='menu-item__header flexRowSBS'>
      <div className='menu-item__header_icons'>
        <p className='menu-item__header_weekday font14EB'>{item ? days[n] : ''}</p>
        <p className='font14EB'>{`${item ?  formattedDate  : ''}`}</p>
        </div>
        <div className='menu-item__header_icons'>
       
        {item._id &&
        <>
          <button type='button' disabled={label1} className='gg-copy s-18-18' onClick={handleOpenCal}>  
           {label1 &&  <TooltipLabel pre='Копирование меню на день' content='Стандарт' subcontent= 'и выше' declension='Доступно'/> } </button>
           <SimpleCalendar 
           meals={[]} 
           choice='choice' 
           isOpen={showCal} 
           userMenu={plans}  
           ref={calRef} 
           handleAddRecipeinMeals={handleCopyPlan} 
           onDayRange={handleDate}/>
           
        </>
        }
        <button type='button' disabled={label1} onClick={handleAutoReplaceMenu} className='gg-replaceDay x-size' >  {label1 &&  <TooltipLabel pre='Автообновление меню на день' content='Стандарт' subcontent= 'и выше' declension='Доступно'/> } </button>
        <button type='button' className='gg-add m-size' onClick={handleOpenAddMeals}> 
        <Popup isOpen={isOpen} ref={mealsRef} type='add-dish'>
          {zeroMeals.map((el, index) =>
            <p className='ing-text font16Norm' key={index} onClick={()=> handleChangeEvents(el)}>
              <span> {el.mealsRu} </span>   
            </p>
          )} 
        </Popup> 
         </button>
       
        {item._id &&
          <button type='button' className='gg-delete-white m-size'onClick={handleDeleteMenuDay} />  
        }
        
        </div>
      </div>
      <div className='menu-item__content'>
        {mainMeals.map((item, index)=> (
          <PatternMeals 
            items={item} 
            planId={props.item._id}
            key={index}
            handleChange={handleChange}
            handleAddDish={handleAddDish} 
            handAutoReplace={handAutoReplace}
            click={click} 
            statusPlan={statusPlan}
            optionsId={props.optionsId}
            clickCreate={props.clickCreate}
            handleDeleteDish={handleDeleteDish}
            handleAddExcessDish={handleAddExcessDish}
            handleDeleteRecipe={handleDeleteRecipe}
            handleEdite={handleEdite}
            handleAutoReplace={handleAutoReplace}
            handleCopyRecipe={props.handleCopyRecipe}
            normalPlans={props.normalPlan} 
            showRecipes={props.showRecipes}
            />
        ))
        }
      
      </div>
      {item._id ?
      <div className='menu-item__footer'>
        <div className='menu-item__footer_price flexRowSB'> 
          <TooltipNo content='Примерная стоимость меню на день на 1 человека' ><span className='gg-coins m-size'></span></TooltipNo> 
          <p className='font12Norm'>~{Math.ceil(calculation.price)} ₽</p>
        </div>
        <ul className='recipe-card__block_calories menu__block_cals menu__footer_cals'> 
          <Cals num={Math.ceil(calculation.protein)} name='Б' measure='г'  type='menu'/>
          <Cals num={Math.ceil(calculation.fats)} name='Ж' measure='г'  type='menu'/>
          <Cals num={Math.ceil(calculation.carb)} name='У' measure='г'  type='menu'/> 
          <Cals num={Math.ceil(calculation.cal)} measure='ккал' type='menu'/>
        </ul>
      </div>
      : 
      <div className='menu-item__footer'>
        <div className='menu-item__footer_price flexRowSB'> 
          <span className='gg-coins m-size'></span>
          <p>~ 0₽</p>
        </div>
        <ul className='recipe-card__block_calories menu__block_cals menu__footer_cals'> 
          <Cals num='0 'name='Б' measure='г' type='footer'/>
          <Cals num='0' name='Ж' measure='г' type='footer'/>
          <Cals num='0' name='У' measure='г' type='footer'/> 
          <Cals num='0' measure='ккал' type='footer'/>
        </ul>
      </div>
    }
    </article>
 
    </> 
  ) 
}


const PatternMeals = ({
  items, 
  handleAddDish, 
  statusPlan, 
  handleChange, 
  click, 
  normalPlans, 
  handleDeleteDish, 
  planId, 
  optionsId, 
  handleAddExcessDish, 
  handleDeleteRecipe, 
  handleEdite, 
  clickCreate,
  handleAutoReplace, 
  handAutoReplace, 
  showRecipes,
  handleCopyRecipe}) => {
  const {arr, mealsRu, mealsEn} = items    
  return (
    <div className='pattern-meals'> 
       {arr.length === 0 ? (
        <PatternDish  
          mealsRu={mealsRu}
          mealsEn={mealsEn}
          clickCreate={clickCreate}
          handleAddDish={handleAddDish}
          handleDeleteDish={handleDeleteDish}
          handAutoReplace={handAutoReplace}
        
      />
      ) : (
        arr.map((item, index) => (
          <MenuDish 
            item={item} 
            planId={planId}
            key={index}
            index={index}
            mealsRu={mealsRu}
            mealsEn={mealsEn}
            statusPlan={statusPlan}
            clickes={click}
            handleAddDish={handleAddExcessDish}
            deleteRecipe={handleDeleteRecipe}
            editeRecipe={handleEdite} 
            handleAutoReplace={handleAutoReplace}
            handleCopyRecipe={handleCopyRecipe}
            optionsId={optionsId}
            normalPlans={normalPlans}
            handleChange={handleChange}
            clickCreate={clickCreate}
            showRecipes={showRecipes}
          />
        ))
      )}
    </div>
  )
}


const PatternDish = ({item, handleAddDish, mealsRu, mealsEn, click, clickCreate, handleDeleteDish, label1, handAutoReplace, returnModal}) => { 
  const {statusPlan} = useSelector(state => state.plans) 
  const [clickes, setClickes] = React.useState(false)
 
  function handleAddNewDish() {
    handleAddDish(mealsRu, mealsEn)
    setClickes(true)
  }

  React.useEffect(()=> {
    if(statusPlan === 'resolved' ) {
      setClickes(false) 
    }
  }, [statusPlan]) 
  
  function handleAutoReplaceDish() { 
    setClickes(true)
    handAutoReplace(mealsRu, mealsEn) 
  }

  return (
    <>
    {(clickes) && (statusPlan === 'loading' )   ?
      <div className='pattern-dish '> 
        <div className="pattern-loader"> 
          <Loader />
        </div>  
      </div>
    :

    <div className='pattern-dish flexRowSB'>
      <div className='pattern-dish_image'>
        <span className='pattern-dish__assign font12Norm'> {mealsRu}    
        </span>
        <button type='button' className='gg-add-free pulse-button l-size' onClick={()=> handleAddNewDish(mealsRu, mealsEn)} />   
      </div>
      <div className='pattern-dish__content'>
        <div className='pattern-dish__heading'>
          <div className='pattern-dish___info'></div>
          <div className='pattern-dish__named'>
          <div className='pattern-dish___title'></div>
          <div className='pattern-dish___subtitle'></div>
          </div>
        </div>
        <ul className='pattern-dish_cals'> </ul>
  
      </div>
      {!label1 &&
        <div className='menu-item__header_icons_col'>
         
         
        </div>  
      }
    </div>
  }
  </>
  )
}


const MenuDish = ({item, handleAddDish, 
  mealsRu, mealsEn, clickCreate, clickes, 
  handleChange, 
  hoax, 
  planId, 
  normalPlans, setHoax, index, 
  deleteRecipe, 
  optionsId, 
  editeRecipe, 
  handleAutoReplace, 
  showRecipes,
  handleCopyRecipe}) => { 
  const { currentUser, rate } = useSelector(state => state.currentUser) 
  const [normalPlan, setNormalPlan] = React.useState(null) 
  const [backupPlan, setBackupPlan] = React.useState(null) // нужен для сохранения предыдущего рецепта если не найдена замена
  const {recipesLimitData, statusLim} = useSelector(state => state.recipes) 
  const {plans, statusPlan, isLoading} = useSelector(state => state.plans)  
  const [price, setPrice] = React.useState({})
  const eventRef = React.useRef()
  const dispatch = useDispatch();
  //const [localLoading, setLocalLoading] = React.useState(false);
  //let recipe = recipesLimitData.find(i=> i._id === item._id)
  const [click, setClick] = React.useState(false) //Отслеживание клика для вывода прелоудера в меню 
  const [isExcess, setIsExcess] = React.useState(false); // Состояние для показа дополнительного окна где правится вес и к-во порций
  //const [time, setTime] = React.useState({}); // Состояние для показа дополнительного окна где правится вес и к-во порций
  const [excessTime, setExcessTime] = React.useState([]); // Состояние для показа дополнительного окна где правится вес и к-во порций
  const {ingredients, status} = useSelector(state => state.ingredients)
  const [showCalendar, setShowCalendar] = React.useState(false)
  const [isDisLiked, setIsDisLiked] = React.useState(false)
  const label1 = rate.subs === 'free'; 
  //const label1 = false
  const [serv, setServ] = React.useState('')
  const [weight, setWeight] = React.useState('')
  const [isOpenReason, setIsOpenReason] = React.useState(false)
  const resultArray = [];
  const possibleWeights = Array.from({length: 16}, (_, i) => 100 + i * 50); // От 100 до 500 с шагом 50
  let inserted = false;   
  const reasonRef =  useRef()  

  React.useEffect(()=> { 
    const recipes = recipesLimitData.find(i=> i._id ===  item._id)
    console.log(recipes)
    if(!recipes) return;
      const time = recipes.times && recipes.times.find(t=> t.timeKey === 'basic')
      setNormalPlan({
        ...item,
        category: recipes.category,
        image: recipes.image[0],
        name: recipes.name,
        time: time ? time.time : recipes.time,
        unitСhoice:  time ? time.unitСhoice : 'мин'
      }) 
      setIsDisLiked(recipes.disLikes.some(i => i === currentUser._id))
      setClick(false); 
      setServ(item.servings)
      setWeight(item.weight)
      setPrice(priceDish(recipes.ingredients, ingredients))
      setExcessTime(recipes.times && recipes.times.filter(t=> t.time!== 0 && t.timeKey !== 'basic'))
    
  }, [item, recipesLimitData]) 
  
    React.useEffect(() => {
    const click = e => {
      if (isOpenReason && reasonRef.current && !reasonRef.current.contains(e.target) && !e.target.classList.contains('gg-dislike') ) {
        setIsOpenReason(false)
      }
     }
    document.addEventListener("mousedown", click)
      return () => {
        document.removeEventListener("mousedown", click)
      }
  }, [isOpenReason])

  for (let i = 0; i < possibleWeights.length; i++) {
    const current = possibleWeights[i];
    // Добавляем число в массив
    if (!inserted && current >= weight) {
      resultArray.push(weight);
      inserted = true;
    }
    resultArray.push(current);
  } 

  React.useEffect(() => {
    if (statusPlan === 'rejected') {
      // Восстанавливаем предыдущее состояние при ошибке
      if (backupPlan) {
        setNormalPlan(backupPlan);
        setServ(backupPlan.servings);
        setWeight(backupPlan.weight);
      }
      setClick(false);
      setIsExcess(false);
    } 
  }, [statusPlan]);
 

 
  React.useEffect(() => {
    if(clickCreate || clickes) {
      setNormalPlan(null)
    }
  }, [clickCreate, clickes]);
 
  function handleDeleteRecipe() { 
    setClick(true)
    setBackupPlan(normalPlan);
    deleteRecipe(normalPlan._id, mealsEn, index) 
    setNormalPlan(null)
  }
  
   function handleAutoReplaceDish() {  
    setBackupPlan(normalPlan);
    setClick(true) 
    handleAutoReplace(normalPlan._id,normalPlan.cal,normalPlan.category, mealsEn, index) 
    setNormalPlan(null)
   } 
  
  function handleEdite() { 
    setBackupPlan(normalPlan); 
    editeRecipe(normalPlan._id, mealsEn, mealsRu, index)
    setNormalPlan(null)
    setClick(true)  
  }

  function handleOpenExcessInfo() {
    setIsExcess(!isExcess)
  }
  
  React.useEffect(() => {
    const click = e => {
      if (showCalendar && eventRef.current && !eventRef.current.contains(e.target) && !e.target.classList.contains('gg-copy-dish') ) {
        setShowCalendar(false)
      }
     }
    document.addEventListener("mousedown", click)
      return () => {
        document.removeEventListener("mousedown", click)
      }
    }, [showCalendar])

  function handleAddRecipeinMeals(el) {
    handleCopyRecipe(el, normalPlan._id)
    setShowCalendar(false)
  }

  function handleDate(date) {  
  }

  //Открытие и закрытие календаря для добавления в рецепт
  function handleOpenCalendar() { 
    setShowCalendar(!showCalendar)
  }

  const handleIncrease = () => {
    setClick(true)
    setServ(serv +1) 
    handleChange(serv +1, weight, normalPlan._id, normalPlan.category, mealsEn, index)
  };
  
  // функция для уменьшения значения
  const handleDecrease = () => {
    setClick(true)
    setServ(Math.max(serv - 1, 1))  
    handleChange(serv - 1, weight, normalPlan._id, normalPlan.category, mealsEn, index)
  }; 

  const increaseWeight = () => {
    setClick(true)
    const nextWeight = resultArray.find(w => w > weight && w !== Math.max(...resultArray));
    if (nextWeight) {
      setWeight(nextWeight); 
    }
    handleChange(serv, nextWeight, normalPlan._id, normalPlan.category, mealsEn, index)
  };

  const decreaseWeight = () => { 
    setClick(true)
    const prevWeight = resultArray.slice().reverse().find(w => w < weight && w !== Math.min(...resultArray));
    if (prevWeight) {
      setWeight(prevWeight); 
    }
    handleChange(serv, prevWeight, normalPlan._id, normalPlan.category, mealsEn, index)
  }; 
  const formatNumber = (num) => {
    const rounded = Math.round(num * 10) / 10; // Округляем до 1 знака
    return rounded % 1 === 0 ? rounded.toString() : rounded.toFixed(1);
  };
 
 
  const handleDislikeOpen = async () => {
  if (!isDisLiked) {
    setIsOpenReason(!isOpenReason);
  } else {
    try {
      // Ждем завершения dispatch
      await dispatch(handleDislikeInPlan({
        planId: planId, 
        reason: 'unknown', 
        recipeId: normalPlan._id, 
        mealType: mealsEn, 
        index: index
      })).unwrap(); // unwrap() для обработки промиса
      
      // Действия после успешного запроса
      alert('Дизлайк успешно удален');
      setIsDisLiked(false); 
      
    } catch (error) {
      console.error('Ошибка при удалении дизлайка:', error);
    }
  }
};


   const handleDislikeClose = () => {
    setIsOpenReason(false); 
  };

  const handleDislikeSubmit = async (recipeId, reason) => {  
    dispatch(handleDislikeInPlan({planId: planId, reason: reason, recipeId: recipeId, mealType: mealsEn, index: index})) 
    setBackupPlan(normalPlan);
    setClick(true) 
    handleAutoReplace(normalPlan._id,normalPlan.cal,normalPlan.category, mealsEn, index) 
    setNormalPlan(null)
     handleDislikeClose()
  };


  return (
    <>
    {statusPlan === 'resolved' && isExcess ?
    <div className='pattern-dish pattern-dish__excess flexColStart'> 
        <div className='menu-dish__heading_excess'>
          <div className='menu-dish___title font18EB color-title'>{normalPlan.name}</div> 
        {/*  <button type='button' className='gg-transfer m-size' onClick={handleOpenExcessInfo}/>*/}
        <button type='button' className='next-button m-size' onClick={handleOpenExcessInfo}/>
        </div>
        <div className='menu-dish__heading_excess'>
        <div className='recipe__block_count'>  
        <div className='recipe__count' >
          <div className='font14Norm relative' >Количество порций 
          {label1 &&  <TooltipLabel pre='Изменение количества порции' content='Стандарт' subcontent= 'и выше' declension='Доступно' type='serv'/> }
          </div>
          
          <InputCounter values={serv}  name='servings' id='servings' disabled={label1} handleIncrease={handleIncrease} handleDecrease={handleDecrease} />
          </div>
          <div className='recipe__count' >
            <div className='font14Norm relative'>Вес порции
            {label1 &&  <TooltipLabel pre='Изменение веса порции' content='Стандарт' subcontent= 'и выше' declension='Доступно' /> }</div>
          <InputCounter values={Math.ceil(weight)} name='weight' id='weight'  disabled={label1} handleIncrease={increaseWeight} handleDecrease={decreaseWeight} />
        </div> </div>
       
        </div> 
      
       
    </div>
    : ( clickes ) && (statusPlan === 'loading' || statusLim ===  'loading' && !isExcess) 
    ||(!normalPlan) || click || clickCreate ?
  <div className='pattern-dish pattern-dish__loader'> 
    <div className="pattern-loader"> 
      <Loader />
    </div>  
  </div>
 : !isExcess && normalPlan &&
<div className='pattern-dish flexRowSB'>
  <div className='menu-dish__image-block'>
   <img  className='menu-dish__image' src={normalPlan.image}/>  
   {index === 0 && 
      <span className='pattern-dish__assign font14Norm' > {mealsRu}
      <button type='button' className='gg-add-dish-white s-14-12' onClick={()=> handleAddDish(mealsRu, mealsEn)} />    
    </span>  
   }
  
    <div className='menu-dish__price font12Norm'>
      {/*excessTime.length> 0 &&
        <TooltipNo content={`Дополнительно требуется ${excessTime[0].label} ${excessTime[0].time} ${excessTime[0].unitСhoice}`} >
          <button type='button' className='gg-note ' />
        </TooltipNo> 
      */}
  {excessTime.filter(item => item.active && item.label !== 'basic').length > 0 && (
  <TooltipNo
    content={`Дополнительно требуется: ${excessTime
      .filter(item => item.active && item.label !== 'basic')
      .map(item => `${item.label} ${item.time} ${findDeclension(item.time, item.unitСhoice)}`)
      .join(', ')}`}
  >
    <button type="button" className="gg-note" />
  </TooltipNo>
)}
    <span className=' font12Norm'>{normalPlan.time} {normalPlan.unitСhoice}</span> 
    <span className='menu-dish__border font12Norm'></span> 
    <span className='  font12Norm'>~{Math.ceil(normalPlan.weight)}г {/* Math.round(price/normalPlan.servings)₽*/} </span>     
    </div>
    </div> 
  <div className='pattern-dish__content'>
    <div className='pattern-dish__heading'>
      <div className='df-c g10'>
      <button type='button' className='gg-info m-size' onClick={handleOpenExcessInfo}/>
      <button type='button' className={`m-size ${isDisLiked ? 'gg-dislike-active' : 'gg-dislike'}`} onClick={handleDislikeOpen}/>
      <Popup isOpen={isOpenReason} ref={reasonRef} type='add-dish'>
        <ReasonDislike 
          onClose={handleDislikeClose}
          onSubmit={handleDislikeSubmit}
          recipeId={normalPlan._id}
        />
      </Popup>
      </div>
      <div className='pattern-dish__named'>
      <Link to={`/recipes/${normalPlan._id}`} target="_blank" className=" color-title" > <div className='menu-dish___title font18EB color-title'>{normalPlan.name}</div> </Link>
       
      </div>
    </div>
    <ul className='recipe-card__block_calories menu__block_cals'> 
      <Cals num={formatNumber(normalPlan.protein)} name='Б' measure='г' type='menu'/>
      <Cals num={formatNumber(normalPlan.fats)}  name='Ж' measure='г' type='menu'/>
      <Cals num={formatNumber(normalPlan.carb)} name='У' measure='г' type='menu'/> 
      <Cals num={Math.ceil(normalPlan.cal)} measure='ккал' type='menu'/>
    </ul>
  </div>
  <div className='menu-item__header_icons_col'>
    <button type='button' className={`s-18-18 ${label1 ? 'gg-copy-disabled' : 'gg-copy-dish'}`} onClick={label1 ? undefined : handleOpenCalendar}> 
    {label1 &&  <TooltipLabel pre='Копирование рецепта на другие дни' content='Стандарт' subcontent= 'и выше' declension='Доступно'/> } </button>
    <SimpleCalendar meals={meals} isOpen={showCalendar} userMenu={plans}  ref={eventRef} handleAddRecipeinMeals={handleAddRecipeinMeals} onDayRange={handleDate}/>
    <button type='button' onClick={label1 ? undefined : handleAutoReplaceDish} className={`m-size ${label1 ? 'gg-replace-disabled' : 'gg-replace'}`} ><TooltipNo content='Автозамена рецепта'/> 
    {label1 &&  <TooltipLabel pre='Автозамена рецепта' content='Стандарт' subcontent= 'и выше' declension='Доступна'/> }
    </button>
    <button type='button' className='gg-edit m-size' onClick={handleEdite}/>  
    <button type='button' className='gg-delete m-size' onClick={handleDeleteRecipe}/>  
  </div>
</div>
 
  }
    </>
  )
}

 